import { Bot, User } from "lucide-react";
import { cn } from "../../lib/utils";

type MessageRole = "user" | "assistant" | "system";

type MessageProps = {
  role: MessageRole;
  content: string;
};

export function Message({ role, content }: MessageProps) {
  if (role === "system") {
    return null;
  }

  const isUser = role === "user";
  const containerClass = cn(
    "fade-in-50 slide-in-from-bottom-1 flex animate-in gap-3 duration-500",
    isUser ? "justify-end" : "justify-start"
  );
  const avatarClass = cn(
    "flex h-8 w-8 shrink-0 items-center justify-center rounded-full",
    isUser ? "bg-gray-900 text-white" : "border border-gray-200 bg-gray-100"
  );
  const bubbleClass = cn(
    "max-w-[80%] rounded-2xl px-4 py-2.5 text-[15px] leading-[22px]",
    isUser
      ? "bg-black text-white"
      : "border border-gray-200 bg-gray-100 text-[var(--franklin-foreground)]"
  );

  return (
    <div className={containerClass}>
      {!isUser && (
        <div className={avatarClass}>
          <Bot className="h-4 w-4 text-gray-700" strokeWidth={2} />
        </div>
      )}
      <div className={bubbleClass}>
        <div className="whitespace-pre-wrap break-words">{content}</div>
      </div>
      {isUser && (
        <div className={avatarClass}>
          <User className="h-4 w-4" strokeWidth={2} />
        </div>
      )}
    </div>
  );
}

export function LoadingMessage() {
  return (
    <div className="fade-in-50 slide-in-from-bottom-1 flex animate-in justify-start gap-3 duration-500">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-gray-100">
        <Bot className="h-4 w-4 text-gray-700" strokeWidth={2} />
      </div>
      <div className="rounded-2xl border border-gray-200 bg-gray-100 px-4 py-2.5">
        <div className="flex gap-1">
          {[0, 150, 300].map((delay) => (
            <div
              className="h-2 w-2 animate-bounce rounded-full bg-gray-400"
              key={delay}
              style={{ animationDelay: `${delay}ms` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
